(function (window, document) {
    'use strict';

    function waitForCore(callback) {
        if (window.FreeBouquetsCore) {
            callback();
            return;
        }

        window.addEventListener('FreeBouquetsCore:ready', function onReady() {
            window.removeEventListener('FreeBouquetsCore:ready', onReady);
            callback();
        });
    }

    function init() {
        const FBC = window.FreeBouquetsCore;
        const data = window.FreeBouquets || {};

        if (!FBC) {
            console.error('FreeBouquetsCore is not loaded');
            return;
        }

        const roots = Array.from(document.querySelectorAll('.ig-offer-progress'));

        if (!roots.length) return;

        const setDisplay = function (selector, value) {
            document.querySelectorAll(selector).forEach(function (item) {
                item.style.display = value;
            });
        };

        const addClass = function (selector, className) {
            document.querySelectorAll(selector).forEach(function (item) {
                item.classList.add(className);
            });
        };

        const removeClass = function (selector, className) {
            document.querySelectorAll(selector).forEach(function (item) {
                item.classList.remove(className);
            });
        };

        const setText = function (selector, text) {
            document.querySelectorAll(selector).forEach(function (item) {
                item.innerText = text;
            });
        };

        const setHtml = function (selector, html) {
            document.querySelectorAll(selector).forEach(function (item) {
                item.innerHTML = html;
            });
        };

        const hideFreeBouquetBanner = function () {
            setDisplay('.ig-free-bouquet-banner', 'none');
        };

        const showFreeBouquetBanner = function () {
            setDisplay('.ig-free-bouquet-banner', '');
        };

        if (!data.customer) {
            setHtml(
                '.ig-offer-progress__info',
                'Sign in to track your <br/> or start your first order now'
            );

            setDisplay('.ig-offer-progress__info-text', 'none');
            removeClass('.ig-offer-progress__btn--ghost', 'hidden');
            hideFreeBouquetBanner();

            return;
        }

        const reward = FBC.getRewardState(data.orders || []);

        hideFreeBouquetBanner();

        if (reward.isLocked) {
            return;
        }

        if (reward.isAlmost) {
            addClass('.ig-offer-progress__point--1', 'is-active');
            removeClass('.ig-offer-progress__days', 'hidden');

            setText('.ig-offer-progress__info', '1 of 2 orders completed');
            setDisplay('#limited-offer', 'none');

            setHtml(
                '[data-offer-days]',
                'Left: <span class="ig-offer-progress__days-value">' + reward.daysLeft + ' day</span>'
            );

            addClass('.ig-offer-progress', 'has-1-active-order');

            return;
        }

        if (reward.isUnlocked) {
            addClass('.ig-offer-progress__point--1', 'is-active');
            addClass('.ig-offer-progress__point--2', 'is-active');
            addClass('.ig-offer-progress__point--3', 'is-active');

            addClass('.ig-offer-progress', 'has-free-bouquet');

            setText('.ig-offer-progress__info', '2 of 2 orders completed');
            setDisplay('#limited-offer', 'none');

            showFreeBouquetBanner();

            if (reward.promoEndDateFormatted) {
                setText(
                    '.ig-free-bouquet-banner__subtitle',
                    'Pick it up before ' + reward.promoEndDateFormatted
                );
            }
        }
    }

    function start() {
        waitForCore(init);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start);
    } else {
        start();
    }
})(window, document);